import React from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';

import isFalsy from 'utils/predicates/isFalsy.util';

import logger from '../../utils/logger.util';

const L = logger('ConfirmationDialog');

const MODAL_STYLE = Object.freeze({
  overlay: {
    zIndex: 500,
  },
});

const MODAL_CLASS = Object.freeze({
  base: 'dialog-container',
  afterOpen: 'dialog-container',
  beforeClose: 'dialog-container',
});

// eslint-disable-next-line react/prefer-stateless-function
class ConfirmationDialog extends React.Component {
  render() {
    const {
      title,
      leftButtonText,
      onLeft,
      rightButtonText,
      onRight,
      disabled: disabledRight,
      disabledLeft,
      children,
      className,
      hideLeft,
      hideRight,
    } = this.props;

    const handleLeft = L.wrap('render()', leftButtonText, onLeft);
    const handleRight = L.wrap('render()', rightButtonText, onRight);

    // noinspection JSUnresolvedFunction
    ReactModal.setAppElement('body'); // stops the modal component from complaining in browser's console

    return (
      <ReactModal
        isOpen
        closeTimeoutMS={0}
        contentLabel={title}
        ariaHideApp
        shouldCloseOnOverlayClick
        role="dialog"
        style={MODAL_STYLE}
        className={MODAL_CLASS}
      >
        <div
          data-bem="ConfirmationDialog__content"
          className={cn({
            dialog: true,
            [className]: className,
          })}
        >
          <div data-bem="ConfirmationDialog__header" className="dialog-header">
            <h2>{title}</h2>
          </div>

          <div data-bem="ConfirmationDialog__body" className="body">
            {children}
          </div>

          <div data-bem="ConfirmationDialog__footer" className="dialog-footer">
            {isFalsy(hideLeft) && (
              <button
                data-bem="ConfirmationDialog__button-left"
                className="btn btn-violet-link"
                tabIndex={0}
                disabled={disabledLeft}
                onClick={handleLeft}
              >
                {leftButtonText}
              </button>
            )}
            {isFalsy(hideRight) && (
              <button
                data-bem="ConfirmationDialog__button-right"
                className="btn btn-violet"
                tabIndex={0}
                onClick={handleRight}
                disabled={disabledRight}
              >
                {rightButtonText}
              </button>
            )}
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default ConfirmationDialog;
